import { render, staticRenderFns } from "./CoachingPage.vue?vue&type=template&id=a20471e8&"
import script from "./CoachingPage.vue?vue&type=script&lang=js&"
export * from "./CoachingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports